import styled from "styled-components";
import { getColor } from "@mzt-monorepo/mzt-atomic";

export const Container = styled.div`
  color: ${getColor("gray")};
  font-size: 10px;
`;
